import { Component, forwardRef, OnDestroy } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { PersonalInfoFormValues } from 'src/app/model';
import { ServicecallService } from 'src/app/services';

@Component({
  selector: 'app-personal-info-form',
  templateUrl: './personal-info-form.component.html',
  styleUrls: ['./personal-info-form.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PersonalInfoFormComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PersonalInfoFormComponent),
      multi: true
    }
  ]
})
export class PersonalInfoFormComponent implements ControlValueAccessor, OnDestroy {


  form: FormGroup;
  genderList: any;
  bloodGroupList: any;
  nationalityList: any;
  maxDate = new Date();
  clearDropDownSearch: boolean = false;
  searchTerm: any = null;

  private _attributes: any = ['gender', 'bloodGroup', 'nationality'];
  private _subscriptions: Subscription[] = [];
  private _valueChangesSubscription: Subscription;
  private _configurationsInfoSubscription: Subscription;

  // bloodGroupList = ['A+', 'A-', 'AB+', 'AB-', 'B+', 'B-', 'O+', 'O-'];
  // genderList = ['Female', 'Male', 'Other'];
  // nationalityList = ['Indian'];

  constructor(
    private _fb: FormBuilder,
    private _service: ServicecallService,
    private _router: Router
  ) {
    this.form = this._fb.group({
      dob: [],
      gender: [],
      nationality: [],
      bloodGroup: []
    });

    this._subscriptions.push(
      // any time the inner form changes update the parent of any change
      this._valueChangesSubscription = this.form.valueChanges.subscribe(value => {
        this.onChange(value);
        this.onTouched();
      })
    );
  }

  ngOnInit(): void {
    this._dropdownConfig();
  }
  triggerEvent(event: any) {
    this.clearDropDownSearch = true;
    this.searchTerm = null;
  }



  get value(): PersonalInfoFormValues {
    return this.form.value;
  }

  set value(value: PersonalInfoFormValues) {
    this.form.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  ngOnDestroy() {
    this._subscriptions.forEach(s => s.unsubscribe());
    this._valueChangesSubscription?.unsubscribe();
    this._configurationsInfoSubscription?.unsubscribe();
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  writeValue(value: PersonalInfoFormValues | null) {
    if (value) {
      this.value = value;
    }

    if (value === null) {
      this.form.reset();
    }
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  // communicate the inner form validation to the parent form
  validate(_: FormControl) {
    return this.form.valid ? null : { personalInfo: { valid: false } };
  }

  private _dropdownConfig() {
    const excludeUrl = ['signup'];
    const urlSplit = this._router.url.split('/');
    if (urlSplit.length >= 2 && excludeUrl.includes(urlSplit[1])) {
      this._configurationsInfoSubscription = this._service.configurationsInfo(this._attributes).subscribe((result: any) => {
        if (result['status']) {
          if (result['response'].length > 0) {
            let data: any = result['response']
            data.forEach((element: any) => {
              if (element['attribute'] === 'gender') {
                this.genderList = element['values']['gender'];
              }
              if (element['attribute'] === 'bloodGroup') {
                this.bloodGroupList = element['values']['bloodGroup'];
              }
              if (element['attribute'] === 'nationality') {
                this.nationalityList = element['values']['nationality'].sort((a, b) => (a.nationality.localeCompare(b.nationality)));
              }
            });
            this.genderList.sort(function (a: any, b: any) {
              if (a.name < b.name) { return -1; }
              if (a.name > b.name) { return 1; }
              return 0;
            })
          }
        }
      });
    } else {
      this.genderList = this._service.getConfiguration('gender') ? this._service.getConfiguration('gender')['gender'] : [];
      this.bloodGroupList = this._service.getConfiguration('bloodGroup') ? this._service.getConfiguration('bloodGroup')['bloodGroup'] : [];
      this.nationalityList = this._service.getConfiguration('nationality') ? this._service.getConfiguration('nationality')['nationality'] : [];
      this.genderList.sort(function (a: any, b: any) {
        if (a.name < b.name) { return -1; }
        if (a.name > b.name) { return 1; }
        return 0;
      });
    }
  }

}
